import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next)
  .init({
    fallbackLng: "jp",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          Login:"Login",
          Email:"Email Address",
          Password:"Password",
          DontHaveAccount:"Don't have an account?",
          ErrorLogin:"Error : Please verify your Login/Password.",
          Continue:"Continue",
          English:"English",
          Japanese:"Japanese",
          Account: "Account",
          Signout: "Sign out",
          OnlineStorage: "Online Storage",
          NewProject: "New project",
          NoProjectYet: "Your account does not contain any project yet.",
          Needmorespace: "Need more space?",
          Getintouchwithus: "Get in touch with us",
          ContactUs: "Contact Us",
          Welcome: "Welcome to Mirukuru Online Storage!",
          PleaseStart:"Please start by creating a project, by clicking on the button [New project].",
          Moused:"GB used on",
          Momax:"GB",
          NewProjectDescription:"To create a new project, please enter a title and a short description.",
          Title:"Title",
          Description:"Description",
          Cancel:"Cancel",
          Create:"Create",
          Creating:"Creating",
          ProjectEmpty:"This project is empty. Please upload some data, by clicking on the button [Upload].",
          UploadData:"Upload",
          Progress:"Progress",
          Edit:"Edit",
          Delete:"Delete",
          SelectALASFile:"Select a file you want to upload in the LAS or LAZ format, give a small description and attach an image. If required, select the processing you need for that file.",
          LASLAZFile:"LAS/LAZ File (required)",
          Image:"Image (10MB maximum)",
          dragndrop:"Drag 'n' drop or click to select",
          Upload:"Upload ",
          Uploading:"Upload",
          ErrorUpload:"An error occured while uploading the data. Please try again.",
          ErrorType:"The file you provided is not in the LAS or LAZ format. Please select a LAS or LAZ file.",
          ErrorSpace:"The file you selected will not fit in your storage space. Get in touch with us to increase your storage space.",
          ErrorMaxFileSpace:"The file you selected exceed the maximum size. Please select a smaller file.",
          ErrorNoFile:"Please select one file.",
          UploadSuccess:"Data uploaded!",
          EditProject:"Edit project",
          PleaseModify:"Please modify the project name and description.",
          NewTitle:"New title",
          NewDescription:"New description",
          Save:"Save",
          Saving:"Saving",
          Products:"Products",
          Download:"Download",
          Share:"Share",
          DeleteProject:"Delete project",
          DeleteProjectDesc:"Any deleted project, including the attached data, cannot be recovered. Please, proceed with caution.",
          Deleting:"Deleting",
          errorDeleteProject:"An error occured while deleteing the project. Please try again.",
          successDeleteProject:"Project deleted!",
          errorEditProject:"An error occured while editing the project. Please try again.",
          successEditProject:"Project modified!",
          errorCreateNewProject:"An error occured during the project creation. Please check that you filled correctly the title and the description.",
          successCreateNewProject:"Project creation successful!",
          Close:"Close",
          ShareFile:"Share file",
          ShareProduct:"Share product",
          ShareFileDesc:"A link to the file, valid for 24 hours, will be automatically copied to your clipboard. Feel free to share this link to your collaborators. Anybody with this link can download the file.",
          CreateLink:"Create link",
          LinkSuccess:"The link has been copied to your clipboard!",
          DeleteFile:"Delete file",
          DeleteFileDesc:"Any deleted File cannot be recovered. The products associated will also be deleted. Please, proceed with caution.",
          successDeleteFile:"Data deleted!",
          errorDeleteFile:"An error occured during the data deletion, please try again.",
          ErrorAlreadyExists:"This file has already been uploaded on your account, please select another one.",
          ForgotPassword:"Forgot your password?",
          ResetPassword:"Reset password",
          ResetPasswordDesc:"Please fill here your email. If your email corresponds to an account in our database, you will receive shortly a verification code for setting up your new password.",
          Send:"Send code",
          SuccessResetPassword:"The code has been successfully sent to your email address.",
          ErrorResetPassword:"The email address your provided does not correspond to any registered account, Please verify that you entered the correct address.",
          NewPasswordDesc:"Please enter here the verification code you received by email and your new password.",
          Code:"Code",
          SuccessNewPassword:"Your password has been changed!",
          ErrorNewPassword:"An error occured while setting your new password. Please check your verification code.",
          errorDownloadFile:"An error occured while downloading the file. Please try again.",
          Searchfile:"Search file",
          Sortby:"Sort by",
          Date:"Date",
          Latest:"Latest",
          Oldest:"Oldest",
          Size:"Size",
          Biggest:"Biggest",
          Smallest:"Smallest",
          File:"File",
          View:"View",
          ErrorPotree:"An error occured during the rendering. Please try again.",
          NewPassword:"Enter your new Password",
          ReNewPassword:"Enter again your new Password",
          minLengthPW: "Password has at least 8 characters.",
					specialCharPW: "Password has special characters.",
					numberPW: "Password has a number.",
					capitalPW: "Password has a capital letter.",
          lowercasePW: "Password has a lowercase letter.",
					matchPW: "Passwords match.",
          TooManyAttempt:"Attempt limit exceeded, please try after some time.",
          CodeMismatchError:"The provided code doesn't match. Please check again your verification code.",
          ViewerNotReady:"The viewer for this file is not ready yet. Please try again after few minutes.",
          UploadingContent:"Uploading content",
          MaximumSize:"Maximum size",
          GettingViewerReady:"The viewer is getting ready.",
          AboutButton:"About",
          About:"About",
          AboutInfo:"Mirukuru Online Storage is a powerful software tool designed for storing and visualizing 3D point clouds online. It enables users to interactively explore and analyze point cloud data with ease.",
          SoftwareStructure:"Software Structure",
          SoftwareStructureInfo:"The software is built on a robust and scalable architecture that handles the secure storage of 3D point cloud data through Amazon Web Services and uses Potree, an open-source point cloud rendering framework, for high-quality and interactive visualization.",
          Potree:"Potree",
          PotreeInfo:"Mirukuru Online Storage uses Potree and Potree Converter for rendering massive point clouds in web browsers. Potree and its converter are renowned for their performance and compatibility with various LiDAR data formats. Both Potree and Potree Converter are under ",
          Contact:"Contact",
          ContactInfo:"For support, inquiries, or feedback, please ",
          ThankYou:"Thank you for choosing Mirukuru Online Storage!",
          TeamSign:"The Mirukuru Team",
          Demo:"This account is intended for demonstration purposes only.",
          UserEmpty:"This user did not upload any data yet.",
          ErrorFileNoSpace:"The name of the file should not contain space character (' '). Please change the file name and try again.",
          NoProductAdmin:"There is no product attached to this file yet.",
          UploadProduct:"Add product",
          AddNewProductAdmin:"Add a new product",
          ErrorConverterHead:"Sorry, the viewer is not available for this file",
          ErrorConverter1:"This can happen for the two following reasons:",
          ErrorConverter2:"Some points fall outside bounding box defined in the LAS header",
          ErrorConverter3:"The Global Encoding (GE) flag is not set to WKT, which is a requirement for Point Data Record Format 6 - 10.",
          ErrorConverter4:"Please try to repair the bounding box, e.g. using lasinfo with the -repair_bb argument, and/or verify that the Global Encoding (GE) flag is set to WKT, then upload your file again.",
          ErrorConverter5:"If the problem persists, do not hesitate to contact our team.",
          SuccessEditUser:"The user has been edited successfully.",
          ErrorEditUser:"An error occured during the user edition.",
          AccountActivity:"Account activity",
          Storage:"Storage ",
          UserCreated:"User created on ",
          Total:"Total ",
          UserSettings1:"User settings",
          UserSettings2:"Storage space",
          UserSettings3:"Maximum size of the directory storing the files uploaded by this user.",
          UserSettings4:"Maximum Go uploaded per month",
          UserSettings5:"During login, we check the number of Go uploaded in the current month by this user. If this number is equal or higher than the limit below, then the user needs to wait for the beginning of the next month to upload a new file.",
          AdminPanel:"Administration panel",
          StorageStatistics:"Storage statistics",
          Empty:"Empty",
          HasBeenAddedToTheFile:" has been added to ",
          CreatedOn:"Created on ",
          UpdatedOn:"Last updated on ",
          EditData:"Edit data",
          PleaseModifyData:"Please provide a new description and/or a new image.",
          SuccessEditFile:"The file has been modified with success",
          ErrorEditFile:"An error occured during the file modification",  
          UploadQueue:"Upload queue",
          UploadCompleted:"Upload completed",  
          UploadFailed:"Upload failed",   
          NewUser:"Create a new user",
          NewUserDescription:"Please fill in the required fields for creating a new user",
          Name:"Name",
          Company:"Company",
          errorCreateNewUser:"An error occured during the user creation.",
          successCreateNewUser:"User creation successful!",
          warningNameNewUser:"Please provide a name for the new user.",
          warningCompanyNewUser:"Please provide a company name for the new user.",
          warningEmailNewUser:"Please provide a valid email for the new user.",
          warningPasswordNewUser:"Please provide a valid password for the new user.",
          FilterUsers:"Filter users",
          LastLogin:"Last login on ",
          MaxUploadReached:"You reached the maximum of upload this month. Please contact us if you need to upload more files.",
          NumberFile:"Files uploaded",
          NumberGo:"Go uploaded",
          MonthlyUsage:"Monthly usage",
          TotalStorage:"Total storage",
          FileNotReadyForDeletion:"This file is currently being processed, please try to delete it again later.",
          ProcessingOptions:"Processing request",
          Requests:"Requests",
          "forest-report":"Forest report",
          "forest-report-diameter":"Diameter",
          "forest-report-position":"Position",
          "forest-report-height":"Height",
          "noise-filtering":"Noise filtering",
          "ground-extraction":"Ground extraction",
          "buildings-segmentation":"Buildings segmentation",
          "trees-segmentation":"Trees segmentation",
          "crowns-analysis":"Tree crowns analysis",
          "Project":"Project",
          Settings:"Settings of the user storage space and monthly quota.",
          HistoryRequests:"History of the processing requests that have been fulfilled for this user.",
          BuildingSegmentation:"Automatically isolates and extracts building structures from urban point clouds. Using advanced clustering and planar fitting, it delineates roofs, facades and edges even in dense city scans. Outputs clean 3D building footprints and meshes ready for urban planning or visualization.",
          "buildings-segmentation-output":"Mesh model for each detected building, exported in .OBJ format",
          CrownsAnalysis:"Tailored to airborne LiDAR surveys, this tool detects individual tree crowns across large forest canopies. It computes key canopy metrics—height and projection area to assess stand health and structure. Results include crown maps in shapefile format for forest ecologists and silvicultural planning.",
          "crowns-analysis-output":"An ESRI Shapefile bundle (.shp/.shx/.dbf/.prj) containing individual tree‐crown polygons.",
          ForestReport:"Generates a comprehensive stand‐level report from ground‐based point clouds. Aggregates tree metrics—diameter at breast height (DBH), height distributions and tree position into a ready‐to‐share CSV.",
          "forest-report-output":"A CSV file listing both per-tree and stand-level statistics derived from the point cloud.",
          GroundExtraction:"A general‐purpose ground‐surface extraction tool that builds accurate digital terrain models (DTMs). Using progressive morphological and interpolation filters, it classifies and retains only ground points even under vegetation or urban clutter, then approximates those ground points by a continuous surface.",
          "ground-extraction-output":"A georeferenced GeoTIFF (.tif) digital terrain model (DTM) representing the bare-earth surface.",
          NoiseFiltering:"Universal denoising to clean up any point cloud before further processing. Applies statistical outlier removal and radius‐based filters to strip away sensor noise and spurious points while preserving fine details. The result is a high‐quality, ready-to-use point cloud that improves accuracy in downstream tasks.",
          "noise-filtering-output":"A cleaned LAZ-compressed point cloud (.laz) with sensor noise and outliers removed.",
          TreeSegmentation:"Designed for ground‐level or low-altitude scans, this module segments each tree into its own point cloud. You get per-tree datasets for biomass estimation, tree‐by‐tree monitoring or detailed modeling.",
          "trees-segmentation-output":"A LAZ-compressed point cloud file (.laz) augmented with an extra TreeID field."
        },
      },
      jp: {
        translation: {
          Login:"ログイン",
          Email:"メールアドレス",
          Password:"パスワード",
          DontHaveAccount:"アカウントをお持ちでないですか？",
          ErrorLogin:"エラー： ログイン/パスワードを確認してください。",
          Continue:"続ける",
          English:"英語",
          Japanese:"日本語",
          Account: "アカウント",
          Signout: "サインアウト",
          OnlineStorage: "オンラインストレージ",
          NewProject: "新プロジェクト",
          NoProjectYet: "アカウントにはまだプロジェクトがありません。",
          Needmorespace: "もっとスペースが必要ですか?",
          Getintouchwithus: "お問い合わせ",
          ContactUs: "連絡先",
          Welcome: "Mirukuru オンラインストレージへようこそ！",
          PleaseStart:"[新規プロジェクト」ボタンをクリックして、プロジェクトを作成することから始めてください。",
          Moused:"GB を",
          Momax:"GB に使用",
          NewProjectDescription:"新しいプロジェクトを作成するには、タイトルと簡単な説明を入力してください。",
          Title:"タイトル",
          Description:"説明",
          Cancel:"キャンセル",
          Create:"作成",
          Creating:"創造する",
          ProjectEmpty:"このプロジェクトは空です。[アップロード] ボタンをクリックして、データをアップロードしてください。",
          UploadData:"アップロード",
          Progress:"進行状況",
          Edit:"エディット",
          Delete:"デリート",
          SelectALASFile:"LASまたはLAZ形式でアップロードしたいファイルを選択し、簡単な説明をつけて画像を添付してください。必要であれば、そのファイルに必要な処理を選択してください。",
          LASLAZFile:"LAS/LAZファイル（必須）",
          Image:"画像 (最大10MB)",
          dragndrop:"ドラッグ＆ドロップまたはクリックで選択",
          Upload:"アップロード",
          Uploading:"アップロード",
          ErrorUpload:"データのアップロード中にエラーが発生しました。もう一度お試しください。",
          ErrorType:"提供されたファイルはLASまたはLAZフォーマットではありません。LASまたはLAZファイルを選択してください。",
          ErrorSpace:"選択したファイルは、お客様のストレージスペースに収まりません。保管スペースを増やすには、当社までご連絡ください。",
          ErrorMaxFileSpace:"選択したファイルが最大サイズを超えています。より小さいファイルを選択してください。",
          ErrorNoFile:"ファイルを1つ選択してください。",
          UploadSuccess:"データは正常にアップロードされた！",
          EditProject:"編集プロジェクト",
          PleaseModify:"プロジェクト名と説明を修正してください。",
          NewTitle:"新しいタイトル",
          NewDescription:"新着情報",
          Save:"保存する",
          Saving:"保存",
          Products:"製品紹介",
          Download:"ダウンロード",
          Share:"シェア",
          DeleteProject:"プロジェクトの削除",
          DeleteProjectDesc:"削除されたプロジェクトは、添付されたデータも含めて復元できません。ご注意ください。",
          Deleting:"削除",
          errorDeleteProject:"プロジェクトの削除中にエラーが発生しました。もう一度やり直してください。",
          successDeleteProject:"プロジェクトは削除された",
          errorEditProject:"プロジェクトの編集中にエラーが発生しました。もう一度やり直してください。",
          successEditProject:"プロジェクトは変更された！",
          errorCreateNewProject:"プロジェクト作成中にエラーが発生しました。タイトルと説明が正しく記入されているか確認してください。",
          successCreateNewProject:"プロジェクトは成功した！",
          Close:"閉じる",
          ShareFile:"シェアファイル",
          ShareProduct:"シェア製品",
          ShareFileDesc:"24時間有効のファイルへのリンクが自動的にクリップボードにコピーされます。このリンクを共同作業者に自由にシェアしてください。このリンクがあれば、誰でもファイルをダウンロードすることができます。",
          CreateLink:"リンク作成",
          LinkSuccess:"リンクがクリップボードにコピーされました！",
          DeleteFile:"ファイルの削除",
          DeleteFileDesc:"削除されたファイルは復元できません。 関連製品も削除されます。ご注意ください。",
          successDeleteFile:"データは削除された！",
          errorDeleteFile:"データ削除中にエラーが発生しました。",
          ErrorAlreadyExists:"このファイルはすでにアカウントにアップロードされています。",
          ForgotPassword:"パスワードを忘れましたか？",
          ResetPassword:"パスワードのリセット",
          ResetPasswordDesc:"ここにあなたの電子メールを記入してください。あなたの電子メールが私たちのデータベースにあるアカウントに対応する場合、あなたは新しいパスワードを設定するための検証コードをまもなく受け取ります。",
          Send:"コードを送信",
          SuccessResetPassword:"コードがお客様のメールアドレスに送信されました。",
          ErrorResetPassword:"入力されたメールアドレスが登録されているアカウントと一致しません。",     
          NewPasswordDesc:"電子メールで受け取った認証コードと新しいパスワードをここに入力してください。",
          Code:"コード",
          SuccessNewPassword:"パスワードが変更されました！",
          ErrorNewPassword:"新しいパスワードの設定中にエラーが発生しました。認証コードを確認してください。",
          errorDownloadFile:"ファイルのダウンロード中にエラーが発生しました。もう一度お試しください。",
          Searchfile:"検索ファイル",
          Sortby:"ソート",
          Date:"日付",
          Latest:"最新",
          Oldest:"最高齢",
          Size:"サイズ",
          Biggest:"最大",
          Smallest:"最小",
          File:"ファイル",
          View:"表示",
          ErrorPotree:"レンダリング中にエラーが発生しました。もう一度お試しください。",
          NewPassword:"パスワードを入力してください。",
          ReNewPassword:"パスワードをもう一度入力してください。",
          minLengthPW: "パスワードは8文字以上。",
					specialCharPW: "パスワードに特殊文字が含まれている。",
					numberPW: "パスワードには番号がある。",
					capitalPW: "パスワードは大文字。",
          lowercasePW: "パスワードは小文字。",
					matchPW: "パスワードは一致する。",
          TooManyAttempt:"試行回数の制限を超えました。時間をおいてからやり直してください。",
          CodeMismatchError:"提供されたコードが一致しません。認証コードをもう一度確認してください。",
          ViewerNotReady:"このファイルのビューアはまだ準備ができていません。数分後に再度お試しください。",
          UploadingContent:"コンテンツのアップロード",
          MaximumSize:"最大サイズ",
          GettingViewerReady:"ビューアーは準備中",
          AboutButton:"お知らせ",
          About:"Mirukuruオンラインストレージについて",
          AboutInfo:"Mirukuruオンラインストレージは、3D点群をオンラインで保存し、可視化するために設計された強力なソフトウェアツールです。点群データをインタラクティブに探索し、簡単に分析することができます。",
          SoftwareStructure:"ソフトウェアの構造",
          SoftwareStructureInfo:"このソフトウェアは、Amazon Web Servicesを通じて3D点群データを安全に保管し、オープンソースの点群レンダリングフレームワークであるPotreeを使用して高品質でインタラクティブなビジュアライゼーションを実現する、堅牢でスケーラブルなアーキテクチャで構築されている。",
          Potree:"Potree",
          PotreeInfo:"MirukuruオンラインストレージはPotreeとPotree Converterを使用し、ウェブブラウザで大規模な点群をレンダリングしています。Potreeとそのコンバーターは、そのパフォーマンスと様々なLiDARデータフォーマットとの互換性で有名です。PotreeとPotree Converterはどちらも ",
          Contact:"連絡先",
          ContactInfo:"サポート、お問い合わせ、ご意見はこちら ",
          ThankYou:"Mirukuruオンラインストレージをご利用いただきありがとうございます！",
          TeamSign:"Mirukuru チーム",
          Demo:"このアカウントはデモンストレーションのみを目的としています。",
          UserEmpty:"このユーザーはまだデータをアップロードしていない。",
          ErrorFileNoSpace:"ファイル名にスペース（' '）を含めてはいけません。ファイル名を変更して再試行してください。",
          NoProductAdmin:"このファイルにはまだ製品は添付されていない。",
          UploadProduct:"製品を追加する",
          AddNewProductAdmin:"新製品を追加する",
          ErrorConverterHead:"申し訳ありませんが、このファイルではビューアは使用できません。",
          ErrorConverter1:"これは以下の2つの理由で起こりうる：",
          ErrorConverter2:"いくつかの点は、LASヘッダーで定義されたバウンディング・ボックスから外れる。",
          ErrorConverter3:"Global Encoding（GE）フラグが WKT に設定されていません。これは Point Data Record Format 6 - 10 の要件です。",
          ErrorConverter4:"例えば、-repair_bb引数付きのlasinfoを使用してバウンディングボックスを修復するか、グローバルエンコーディング（GE）フラグがWKTに設定されていることを確認してから、ファイルを再度アップロードしてください。",
          ErrorConverter5:"それでも問題が解決しない場合は、遠慮なく弊社までご連絡ください。",
          SuccessEditUser:"ユーザーが正常に編集されました。",
          ErrorEditUser:"ユーザーエディット中にエラーが発生しました。",
          AccountActivity:"アカウント活動",
          Storage:"ストレージ ",
          UserCreated:"ユーザー作成日 ",
          Total:"合計 ",
          UserSettings1:"ユーザー設定",
          UserSettings2:"収納スペース",
          UserSettings3:"このユーザーがアップロードしたファイルを格納するディレクトリの最大サイズ。",
          UserSettings4:"月間最大アップロード数",
          UserSettings5:"ログイン中に、このユーザーが当月にアップロードした囲碁の数をチェックします。この数が以下の制限値以上である場合、ユーザーは新しいファイルをアップロードするために、次の月の初めまで待つ必要があります。",
          AdminPanel:"管理パネル",
          StorageStatistics:"ストレージ統計",
          Empty:"空",
          HasBeenAddedToTheFile:" が追加された。ファイル: ",
          CreatedOn:"作成日 ",
          UpdatedOn:"最終更新日 ",
          EditData:"データ編集",
          PleaseModifyData:"新しい説明文または新しい画像を提供してください。",  
          SuccessEditFile:"ファイルが変更されました。",
          ErrorEditFile:"ファイル変更中にエラーが発生しました。",
          UploadQueue:"アップロードキュー",
          UploadCompleted:"アップロード完了",  
          UploadFailed:"アップロード失敗",
          NewUser:"新規ユーザーの作成",
          NewUserDescription:"新規ユーザー作成に必要な項目を入力してください。",
          Name:"氏名",
          Company:"会社",
          errorCreateNewUser:"ユーザー作成中にエラーが発生しました。",
          successCreateNewUser:"ユーザー作成に成功しました。",
          warningNameNewUser:"新しいユーザーの名前を入力してください。",
          warningCompanyNewUser:"新規ユーザーの会社名をご記入ください。",
          warningEmailNewUser:"新規ユーザーの有効な電子メールを入力してください。",
          warningPasswordNewUser:"新しいユーザーの有効なパスワードを入力してください。",
          FilterUsers:"フィルターユーザー",
          LastLogin:"最終ログイン日 ",
          MaxUploadReached:"今月のアップロードは上限に達しました。それ以上のファイルをアップロードする必要がある場合は、お問い合わせください。",
          NumberFile:"アップロードされたファイル数",
          NumberGo:"アップロードされた GB 数",
          MonthlyUsage:"月間利用枠",
          TotalStorage:"総貯蔵量",
          FileNotReadyForDeletion:"このファイルは現在処理中です。しばらくしてからもう一度お試しください。",
          ProcessingOptions:"処理要求",
          Requests:"要求",
          Options:"オプション",
          "forest-report":"森林レポート",
          "forest-report-diameter":"直径",
          "forest-report-position":"ポジション",
          "forest-report-height":"高さ",
          "noise-filtering":"ノイズ・フィルタリング",
          "ground-extraction":"地上抽出",
          "buildings-segmentation":"建物セグメント",
          "trees-segmentation":"樹木のセグメンテーション",
          "crowns-analysis":"樹冠分析",
          "Project":"プロジェクト",
          Settings:"ユーザーのストレージ容量と月間クォータの設定。",
          HistoryRequests:"このユーザーに対して実行された処理要求の履歴。",
          BuildingSegmentation:"都市の点群から建物の構造を自動的に分離して抽出します。高度なクラスタリングと平面フィッティングを使用して、密集した都市スキャンでも屋根、ファサード、エッジを明確にします。都市計画やビジュアライゼーションに使用できるクリーンな 3D 建物フットプリントとメッシュを出力します。",
          "buildings-segmentation-output":".OBJ形式でエクスポートされた、検出された各ビルのメッシュモデル",
          CrownsAnalysis:"エアボーンLiDAR調査に合わせて開発されたこのツールは、大規模な森林キャノピーの個々の樹冠を検出します。樹冠の主要な指標である高さと投影面積を計算し、林冠の健全性と構造を評価します。結果には、森林生態学者や造林計画用のシェープファイル形式の樹冠マップが含まれます。",
          "crowns-analysis-output":"個々の樹冠ポリゴンを含むESRI Shapefileバンドル（.shp/.shx/.dbf/.prj）。",
          ForestReport:"地上ベースの点群からスタンドレベルの包括的なレポートを生成します。樹木の指標（胸高直径（DBH）、高さ分布、樹木の位置）をすぐに共有できるCSVに集約します。",
          "forest-report-output":"点群から得られた樹木ごとの統計情報とスタンドレベルの統計情報の両方をリスト化したCSVファイル。",
          GroundExtraction:"高精度なデジタル地形モデル（DTM）を構築する汎用の地表面抽出ツール。漸進的なモルフォロジカルフィルタと補間フィルタを用いて、植生や都市クラッタ下でも地表点のみを分類・保持し、それらの地表点を連続曲面で近似する。",
          "ground-extraction-output":"ジオリファレンス付きGeoTIFF（.tif）デジタル地形モデル（DTM）。",
          NoiseFiltering:"ユニバーサルなノイズ除去機能により、処理前に点群データをクリーンアップ。統計的な異常値除去と半径ベースのフィルタを適用し、微細なディテールを保持しながら、センサーノイズやスプリアスポイントを除去します。その結果、高品質ですぐに使用できる点群が得られ、下流のタスクの精度が向上します。",
          "noise-filtering-output":"センサーノイズと外れ値を除去したLAZ圧縮点群（.laz）。",
          TreeSegmentation:"地上または低高度のスキャン用に設計されたこのモジュールは、各樹木を独自の点群に分割します。バイオマス推定、樹木ごとのモニタリング、または詳細なモデリングのための樹木ごとのデータセットが得られます。",
          "trees-segmentation-output":"LAZ圧縮された点群ファイル(.laz)にTreeIDフィールドを追加したもの。"          
        },
      },
    },
  });

export default i18n;